import type { TFunction } from 'i18next'

export const WAREHOUSE_DEBT_LIMIT_NOTIFICATION_TYPE =
  'warehouse_debt_limit_consumed'

const readString = (
  payload: Record<string, unknown> | undefined,
  key: string
): string => {
  const value = payload?.[key]
  return typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : ''
}

export function getWarehouseDebtLimitNotificationText(
  t: TFunction,
  payload: Record<string, unknown> | undefined
): { title: string; message: string } {
  return {
    title: t(`notifications.${WAREHOUSE_DEBT_LIMIT_NOTIFICATION_TYPE}.title`),
    message: t(
      `notifications.${WAREHOUSE_DEBT_LIMIT_NOTIFICATION_TYPE}.message`,
      {
        warehouse: readString(payload, 'warehouse_name'),
        remaining: readString(payload, 'remaining_limit_display'),
      }
    ),
  }
}

export const warehouseDebtLimitLink = (warehouseId: number): string =>
  `/debt/warehouse-debt-limits?warehouse=${warehouseId}`
